<template>
    <NuxtLayout name="event-overview">
        <NuxtPage />
    </NuxtLayout>
</template>

<script>
export default {
    head() {
        return {
            meta: [
                {hid: 'robots', name: 'robots', content: 'noindex'}
            ]
        }
    }
}
</script>

<style scoped>

</style>
